// Loading.js
import { withStyles } from '@material-ui/core'
import React from 'react'
import styles from './styles'

const Loading = props => {
  const { classes, isBuilding = false } = props

  // Full builds show BuildProgressBubble instead, so this is mostly "Thinking..."
  const getLoadingText = () =>
    isBuilding ? 'Building the Interaction…' : 'Thinking...'

  return (
    <div className={classes.skeletonContainer}>
      <div className={classes.skeletonText}>{getLoadingText()}</div>
      <div className={classes.skeletonBlocks}>
        <div className={classes.skeletonRow}>
          <div className={classes.skeletonBlock1}></div>
          <div className={classes.skeletonBlock2}></div>
          <div className={classes.skeletonBlock3}></div>
        </div>

        <div className={classes.skeletonRow}>
          <div className={classes.skeletonBlockBottomLeft}></div>
          <div className={classes.skeletonBlockBottomRight}></div>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(Loading)
